import { StarbucksConsumptionType } from './starbucks_consumption_type.js';

export function name(consumptionType: StarbucksConsumptionType): string {
  switch (consumptionType) {
    case StarbucksConsumptionType.InStore:
      return 'In-Store';
    case StarbucksConsumptionType.OutOfStore:
      return 'Out-of-Store';
  }
}
